<template>
  <div id="app">
      <!--div class="container" @click="uppdateraRullgardin()"-->
      <div class="container" >
    <!--img alt="Vue logo" src="./assets/logo.png"-->
    <div @click="uppdateraRullgardin()">
    <HeaderField :key="stangning" />
  </div>

    <router-view ></router-view>
</div>
    <Footern/>
  </div>
</template>

<script>
import HeaderField from './components/HeaderField.vue'
import Footern from './components/Footern.vue'
export default {
  name: 'app',
  components: {
    HeaderField,
    Footern
},
data() {
    return {
        stangning: 0,
    }
},

mounted() {
    if(localStorage.done) {
        this.done = localStorage.done
    }
},
methods: {

    persist() {
      localStorage.done = this.done;
  },
  uppdateraRullgardin: function() {
      this.stangning++;

  }

}
}
</script>

<style>

html, body {
    height: 100%;
    margin:0;
}


body {

     overflow-y:scroll;
}

h3 {
    font-family: serif;
    font-size: 2em;
    /*margin-top: 0.5em;*/
    margin-top: 0em;
    padding-top: 0.5em;
}

@media (max-width:570px) {
    h3.goth {
        font-size: 1.4em;
    }
}

h2 {
    font-family: serif;
    font-size: 2em;
    /*margin-top: 0.5em;*/
    margin-top: 0em;
    padding-top: 0.5em;
}

@media (max-width:570px) {
    h2.goth {
        font-size: 1.4em;
    }
}





#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
  min-height: 100%;

  background: url(assets/freiburg6.webp) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  margin: 0;
}


.container {
    min-height: 100vh;
}

.up {
    animation: rotate-up 0.5s;
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

@keyframes rotate-up {
    0% {
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
    }
    100% {
        transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
    }

}


.down {
    animation: rotate-down 0.5s;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

@keyframes rotate-down {
    0% {
        transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
    }
    100% {
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
    }
}

.left {
    animation: rotate-left 0.5s;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

@keyframes rotate-left {
    0% {
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
    }
    100% {
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
    }

}


.right {
    animation: rotate-right 0.5s;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

@keyframes rotate-right {
    0% {
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
    }
    100% {
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
    }
}





@font-face {
    font-family: 'CloisterBlackLight';
    /*src: url('./fonts/cloisterblack.ttf') format('truetype');*/
    font-weight: normal;
    font-style: normal;
}


p {
    line-height: 1.5;
}


h1.fontface {
    font-weight: normal;
}



.visa, .dolj {
    cursor: pointer;
}
.down:hover, .up:hover {
    border-color: #777;
    transition: 0.5;
}



.istyle {
  border: solid #d5dadd;;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
}


.fakta, table {
    margin:auto;
}


.fakta {
    padding-left: 3px;
    padding-right: 3px;

    float: left;

    background-image: url(assets/textured_paper.png);
    background-repeat:repeat;

    padding: 1em 2em 1em 2em;

    -moz-transition: margin-left 0.5s;
    -ms-transition: margin-left 0.5s;
    -o-transition: margin-left 0.5s;
    -webkit-transition: margin-left 0.5s;
    transition: margin-left 0.5s;

    width: 380px;
    /*max-height: calc(100vh - 218px);*/
    max-height: 85vh;
    left:0px;


    margin-left: -470px;

    color: black;
    overflow-y: scroll;
    z-index:7;
    position:relative;
}

@media (max-width: 1024px) {
    .fakta {
        width: calc(100vw - 83px);
        margin-left: calc(-100vw);
    }
}


.fakta::-webkit-scrollbar {
    width: 6px;
    background-color: #F5F5F5;
}

.fakta::-webkit-scrollbar-thumb {
    background-color: #000000;
}
.fakta::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    /*background-color: #F5F5F5;*/
    /*background-color: #caa88e;*/
    background-color: white;
}

.bredd {

    margin-left: 0;
    display: block;

}

.grammatik {
    position: sticky;
    /*top:0;*/
    top:68px;
    z-index:7;
}

.leftorient {
    text-align: left;
    color: black;
}

td {
    padding-left: 0.5em;
    padding-right: 0.5em;
}
.upperspace {
    padding-top: 0.25em;
}

.grammatikparagrafbredd {
    max-width: 40em;
    margin:auto;
}

@media (max-width:1024px) {
    .grammatikparagrafbredd {
        max-width: 100%;
    }
}


.dubbelrad {
    display: inline-block;
}
.p-stil {
    display: inline;
}
.upp {
    vertical-align: top;
    display: inline;
}

.minitext {
    display: inline-block;
    font-size: 0.7em;
}

.quasi-p{
    margin-top: 0.7em;
    margin-bottom: 0.7em;
}

.lite-marginal {
    margin-bottom: 0;
    margin-top:0.5em;
}

th {
    font-weight: normal;
    text-decoration: underline;
}

.linjer {
  border-collapse: collapse;
}

.linjer th, .linjer td {
  border: 1px solid black;
  text-decoration: none;
}
.accented {
    color: brown;
    display: inline;
}

.gra {
    color: #555;
}

.understryk {
    /*background-color: #F66;*/
    background-color: #e4c857;
    display: inline;
}

.understryk-gron {
    /*background-color: #F66;*/
    background-color: #5C5;
    display: inline;
}

.understryk-rod {
    /*background-color: #F66;*/
    background-color: #F55;
    display: inline;
}

.understryk-rosa {
    /*background-color: #F66;*/
    background-color: pink;
    display: inline;
}

.understryk-gul {

    background-color: #EE5;
    display: inline;
}


.inlajn {
    display: inline;
}

.quasi-p{
    margin-top: 0.7em;
    margin-bottom: 0.7em;
    line-height: 1.5em;
}


.vit {
    background-color: white;
}

.ljusgra {
    background-color: #bbb;
}

.gul {
    background-color: #FF7;

}

.rosa {
    background-color: pink;
}

.mindre {
    font-size: 80%;
}


.rod {
    color: red;
}

.bla {
    color: #06F;
}

.gron {
    color: #0A0;
}

.brun {
    /*color: #ff6600;*/
    color: #cc6600;
}


.bgbla {
    background-color: #68F;
}

.bggron {
    background-color: #7D7;
}


.bgrod {
    background-color: #F77;
}

.bggra {
    background-color: #DDD;
}

.bggul {
    background-color: #EE5;
}

.bgljusgul {
    background-color: #FF7;
}

.bgbrun {
    background-color: #A71;
}

.bgvit {
    background-color: #ecc781;
}

.inlajn {
    display: inline;
}

.ljusbla {

    color: #0AC;
    display: inline;
}

.ruta {
    box-sizing: border-box;
    border-style: solid;
    border-width: 1px;
    border-color: black;
    background-color: #EEE;
    padding: 0 1em;
}

.storre {
    font-size: 1.5em;
    display: inline;
}

.mariginal-ner {
    border-spacing: 0 0.5em;
}


h4 {
    font-family: serif;
    font-size: 1.3em;
}

.tippad {
    transform: rotate(-90deg);
}
.slimmad {
    width:2em;
}
.fixbredd {
    table-layout: fixed;
}
.roterad {
    transform: rotate(-90deg);
}

.smalnad {
    max-width: 1em;

}
.marginuppe {
    margin-top: 20px;
}

.ej-lila a:visited {
    color: inherit;
}

.x-pad {
    padding-top:5px;
    padding-bottom:5px;
}
.inramad {
    border: solid 1px;
}

.osynlig {
    display: none;
}
</style>
